<template>
  <div id="SearchPanel">

    <div class="topnav" style="float:left;top: -3px;">
      <div class="search-container">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16"
          style="padding: 3px;border-radius: 0px;float: left;top: 0px;left: -4px;position: relative;">
          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
        </svg> -->
        <form v-on:keydown.13.capture.prevent.stop autocomplete="off" style="width: 270px;">
          <input :disabled="Object.keys(outputs.szafa).length === 0" class="form-control form-control-sm" type="text" :placeholder="$t('message.wyszukaj_produkt')" name="search"
            v-model="searching" @input="search_product">
        </form>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="bi bi-search" style="background: rgb(0, 195, 255); padding: 6px; width: 39px; height: 31px; border-radius: 0px;">
          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" style="color: white;"></path>
        </svg>

      </div>

      <transition name="fade">
      <div id="productsList" v-if="SearchProduct.length > 0">
      <ul class="list-group">
        <li class="list-group-item" v-for="(item, index) in SearchProduct" :key="index">
          <button @click="wybranie_akcesorium_search(item)">{{item.symbol}} - {{item.nazwa}}</button></li>
      </ul>
      </div>
      </transition>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../../mixins/app'

export default {
  name: 'Koszyk',
  mixins: [app],
  data () {
    return {
      searching: '',
      listSearchProduct: []
    }
  },
  computed: {
    ...mapGetters('app', ['inputs', 'outputs']),
    ...mapGetters('products', ['ListaSzafy', 'ListaAkcesoria']),
    SearchProduct () {
      return this.listSearchProduct
    }
  },
  methods: {
    search_product () {
      if (event.keyCode === 13) {
      } else {
        this.listSearchProduct = []
        if (this.searching.length > 2) {
          this.ListaAkcesoria.akcesoria.filter((item) => {
          // console.log(item.symbol.startsWith(this.searching))
            if (item.symbol.toLowerCase().includes(this.searching.toLowerCase()) || item.nazwa.toLowerCase().includes(this.searching.toLowerCase())) {
              item.grupa = 'pozostale'
              this.listSearchProduct.push(item)
            }
          })
        }
        if (this.searching.length > 2) {
          this.ListaAkcesoria.obudowy.filter((item) => {
          // console.log(item.symbol.startsWith(this.searching))
            if (item.symbol.toLowerCase().includes(this.searching.toLowerCase()) || item.nazwa.toLowerCase().includes(this.searching.toLowerCase())) {
              item.grupa = 'obudowy'
              this.listSearchProduct.push(item)
            }
          })
        }
        if (this.searching.length > 2) {
          this.ListaAkcesoria.zasilacze.filter((item) => {
          // console.log(item.symbol.startsWith(this.searching))
            if (item.symbol.toLowerCase().includes(this.searching.toLowerCase()) || item.nazwa.toLowerCase().includes(this.searching.toLowerCase())) {
              item.grupa = 'zasilacze'
              this.listSearchProduct.push(item)
            }
          })
        }
        if (this.searching.length > 2) {
          this.ListaAkcesoria.switche.filter((item) => {
          // console.log(item.symbol.startsWith(this.searching))
            if (item.symbol.toLowerCase().includes(this.searching.toLowerCase()) || item.nazwa.toLowerCase().includes(this.searching.toLowerCase())) {
              item.grupa = 'switche'
              this.listSearchProduct.push(item)
            }
          })
        }
        this.listSearchProduct.sort()
      }
    },
    wybranie_akcesorium_search (item) {
      this.searching = ''
      this.search_product()

      // if (item.grupa === 'zasilacze') {
      //   this.akcesorium_zasilacze = item
      // } else if (item.grupa === 'switche') {
      //   this.akcesorium_switche = item
      // } else if (item.grupa === 'obudowy') {
      //   this.akcesorium_obudowy = item
      // } else if (item.grupa === 'pozostale') {
      //   this.akcesorium_pozostale = item
      // } else {
      // }

      this.wybranie_akcesorium(item)
    },
    wybranie_akcesorium (item) {
      // console.log(grupa, item)
      this.clearViewAkcesorium = false
      if (Object.keys(item).length > 0) {
        this.$store.commit('app/ADD_ITEM', item)
        // this.$store.commit('app/ADD_ITEMS', ['przod', selected])
      }
      this.selectedAkcesoria = item
    }
  }
}
</script>

<style>
#SearchPanel {
  margin-left: 10px;
}
.search-container form input  {
  width: 225px !important;
border-radius: 0px !important;
}

.form-control:disabled, .form-control[readonly] {
  background-color: #e3e3e3;
opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/SearchPanel.vue